import * as types from "./mutation_types";

export default {
  [types.DR_RESET](state) {
    Object.assign(state, {
      error: "",
      isLoading: false,
      items: null,
      previous: null,
      next: null,
    });
  },

  [types.DR_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.DR_SET_ITEMS](state, items) {
    Object.assign(state, { items });
  },

  [types.DR_TOGGLE_LOADING](state) {
    Object.assign(state, { isLoading: !state.isLoading });
  },
};
